'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Pressable, { PressableProps } from '../../pressable'

/* -----------------------------------------------------------------------------
 * FieldIcon
 * -------------------------------------------------------------------------- */

export type FieldIconProps = PressableProps & {
  icon: React.ReactNode
  onPress: () => void
}

const FieldIcon = ({ icon, onPress, ...props }: FieldIconProps) => {
  return (
    <Pressable
      onPress={onPress}
      position='absolute'
      zIndex={1}
      top='50%'
      right={4}
      mt={-20 as any}
      width={40}
      height={40}
      alignItems='center'
      justifyContent='center'
      {...props}
    >
      {icon}
    </Pressable>
  )
}

export default FieldIcon
